import { RawStatusCode } from "@/types/DocumentStatuses";
import { FlowCode, RawElement, StatusCode } from "@/types/generated/ExperienceRawServiceApi";
import objectAssignDeep from "object-assign-deep";

/**
 * This function is used to get the initial values for the RawElement type.
 *
 * @param overrides - An optional parameter used to overwrite the default initial values.
 */
export function getExperienceRawInitialValues(
  overrides?: Partial<RawElement>
): Omit<RawElement, "experience_id" | "status_code" | "flow_code"> {
  const initialValues: RawElement = {
    functional: {
      additional_cities: [],
      venues: [],
      options: [],
      highlights: [],
      included: [],
      non_included: [],
      important_information: [],
      // NOTE: additional services are now managed using typed fields (duration, features, product_brand, etc.)
      // by the section stores (settings, content, distribution-tags) and should not be included here
      categories: [],
      interests: [],
      external_reference_code: "",
      location: undefined,
      markets: [],
    },
    commercial: {
      title: "",
      description: "",
      additional_description: "",
      meeting_point_details: "",
      custom_highlights: [],
      custom_included: [],
      custom_non_included: [],
      custom_important_information: [],
    },
    experience_id: "",
    flow_code: FlowCode.BASE,
    status_code: StatusCode.IN_CREATION,
    collection_criteria: {
      best_value_guaranteed: "",
      created_with_care: "",
      exceptional_experiences: "",
    },
  };

  return objectAssignDeep(initialValues, overrides);
}
